import React, { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import { api, errorDetail } from "@/lib/api";
import { Pill } from "@/components/common";
import { OPTS } from "@/components/AddCandidateParts";
import { toast } from "sonner";
import { useI18n } from "@/lib/i18n";
import { tk } from "@/i18n";
import { fmtNumber, fmtShortDate } from "@/i18n/format";

const label = (t, k, v) => t((OPTS[k] || []).find(([x]) => x === v)?.[1] || v);
const ROWS = [["salutation", tk("Title")], ["seniority", tk("Seniority")], ["availability", tk("Availability")], ["notice_period", tk("Notice period")], ["mobility", tk("Geographic mobility")],
  ["remote_preference", tk("Remote work")], ["candidate_source", tk("Candidate source")], ["other_url", tk("Other link (portfolio, GitHub…)")]];

export function RecruiterInfo({ c }) {
  const { t } = useI18n();
  const r = c.recruiter_info || {};
  const money = (v) => (v || v === 0 ? `${fmtNumber(v)} ${r.salary_currency || ""}` : null);
  const rows = [...ROWS.map(([k, l]) => [l, r[k] ? (k === "other_url" ? <a href={r[k]} target="_blank" rel="noreferrer" className="text-primary underline">{r[k]}</a> : label(t, k, r[k])) : null]),
    [tk("Desired contract"), (r.contract_types || []).map((x) => label(t, "contract_types", x)).join(", ") || null],
    [tk("Current salary (gross / year)"), money(r.current_salary)], [tk("Expected salary (gross / year)"), money(r.expected_salary)]].filter(([, v]) => v);
  if (!rows.length && !c.tags?.length) return null;
  return (
    <div className="space-y-2" data-testid="recruiter-info">
      <dl className="grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs">{rows.map(([l, v]) => <React.Fragment key={l}><dt className="text-muted-foreground">{t(l)}</dt><dd className="font-medium break-words">{v}</dd></React.Fragment>)}</dl>
      {c.tags?.length > 0 && <div className="flex flex-wrap gap-1">{c.tags.map((x) => <Pill key={x} tone="indigo">{x}</Pill>)}</div>}
    </div>
  );
}

export function CandidateFiles({ id }) {
  const { t } = useI18n();
  const [files, setFiles] = useState([]);
  useEffect(() => { api.get(`/candidates/${id}/files`).then((r) => setFiles(r.data)).catch(() => {}); }, [id]);
  const download = async (f) => {
    try {
      const { data } = await api.get(`/candidates/${id}/files/${f.id}/download`, { responseType: "blob" });
      const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(data), download: f.filename });
      a.click(); URL.revokeObjectURL(a.href);
    } catch (e) { toast.error(errorDetail(e)); }
  };
  if (!files.length) return null;
  return <div className="space-y-1" data-testid="candidate-files">{files.map((f) => (
    <button key={f.id} onClick={() => download(f)} className="w-full flex items-center gap-2 text-xs rounded-md bg-muted px-2.5 py-1.5 hover:bg-accent" data-testid={`candidate-file-${f.id}`}>
      <FileText className="w-3.5 h-3.5 text-primary" /><span className="flex-1 text-left truncate">{f.filename}</span><span className="text-muted-foreground">{fmtShortDate(f.created_at)}</span><Download className="w-3.5 h-3.5" /></button>))}</div>;
}
